import { ReportCategory, ReportType, TKeyValuePair } from "emr-ng-shared";

export class ScheduledReportParams {
    ReportParams: TKeyValuePair[];
    EmailSubject: string;
    IsValid: Boolean;
    ReportType: ReportType;
    ReportCategory: ReportCategory;
}
